import styled from 'styled-components';

export const Wrapper = styled.div``;

export const AbsentNutrientsWrapper = styled.div`
  margin: 1rem 0;
  > p {
    font-size: 1.2rem;
  }
`;

export const NutrientListItem = styled.div`
  height: 2rem;
  font-size: 1.4rem;
  line-height: 2rem;
  white-space: nowrap;

  > span {
    display: inline-block;
    position: relative;
    width: 70%;

    &:first-child {
      text-align: right;
      width: 100px;
      padding-right: 1rem;
    }

    &:nth-child(2) {
      background: rgba(255, 255, 255, 0.05);

      &::after {
        content: attr(data-value);
        width: 50px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 1.2rem;
        opacity: 0.7;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.15);

        &::after {
          opacity: 1;
        }
      }
    }


  }
`;

export const NutrientsNav = styled.nav`
  padding: 1rem 0;
  text-align: center;

  > a {
    padding: 1rem;
    cursor: pointer;
    opacity: 0.85;
    user-select: none;

    &[data-active="true"] {
      text-decoration: underline;
      opacity: 1;
    }
  }
`;

export const StatsSection = styled.section`

  margin: 0 0 3rem 0;

  > h4 {
    padding: 0 0 0 100px;
    margin: 1rem 0 2rem;
  }
`;

export const BarWrapper = styled.div`
  height: 16px;
  width: 70%;
  padding: 0 20px 0 0;

  > div {
    display: inline-block;
    height: 14px;
    background: rgba(255, 255, 255, 0.85);
    position: relative;

    > span {
      position: absolute;
      right: -55px;
      top: -2px;
      width: 50px;
      font-size: 1.2rem;

      &:after {
        content: '%';
        opacity: 0.5;
      }

    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/NutrientStats/NutrientStatsStyles.js